















import MapyCzOrthoPhotoLayer from '@/components/maps/MapyCzOrtophotoLayer.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {LControl, LMap, LMarker} from 'vue2-leaflet';

@Component({components: {MapyCzOrthoPhotoLayer, LMap, LMarker, LControl}})
export default class MapyCzOrthoPhoto extends Vue {

    protected get coordinates() {
        return [this.latitude, this.longitude];
    }
    @Prop({required: true, type: Number})
    public readonly longitude: number;

    @Prop({required: true, type: Number})
    public readonly latitude: number;

    private zoom = 18;

    protected maxPopupHeight: number | null = null;

    /**
     * When initialized in parent with display: none, map dimensions cannot be calculated,
     * so these need to be recalculated when map is finally visible
     */
    public visibilityChanged(isVisible: boolean): void {
        if (! isVisible) {
            return;
        }

        this.redrawMap();
    }

    protected updateHeight(): void {
        const container = this.$refs.container as Element;

        this.maxPopupHeight = container.clientHeight * 0.8;
    }

    private redrawMap(): void {
        const map = (this.$refs.container as LMap).mapObject;

        map.invalidateSize();
    }
}
